<template>
  <div class="bg-white border-radius-lg">
    <highcharts
      :options="computedOptions"
      class="border-radius-lg p-1"
      style="height: 50dvh;"
    ></highcharts>
  </div>
</template>

<script>
export default {
  name: "ChartTendencias",
  props: {
    categories: {
      type: Array,
      required: true
    },
    anulaciones: {
      type: Array,
      required: true
    },
    ventas: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: "Tendencias de ventas"
    },
    subtitle: {
      type: String,
      default: "Ventas y Anulaciones"
    }
  },
  computed: {
    computedOptions() {
      return {
        chart: {
            type: 'bar'
        },
        title: { text: this.title },
        subtitle: { text: this.subtitle },
        xAxis: {
            categories: this.categories,
            title: {
                text: 'Afiliados'
            },
            gridLineWidth: 1,
            lineWidth: 0
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
                align: 'high'
            },
            labels: {
                overflow: 'justify'
            },
            gridLineWidth: 0
        },
        plotOptions: {
            bar: {
                borderRadius: '50%',
                dataLabels: {
                    enabled: true
                },
                groupPadding: 0.1
            }
        },
        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'top',
            x: -40,
            y: 80,
            floating: true,
            borderWidth: 1,
            backgroundColor: '#FFFFFF',
            shadow: true
        },
        series: [
          {
            name: 'Ventas',
            data: this.ventas,
            color: '#8B46CD'
          }, {
            name: 'Anulaciones',
            data: this.anulaciones,
            color: '#d1d1d1'
          }
        ],
      };
    }
  }
};
</script>
<styles lang="scss" scoped>
  .highcharts-xaxis-labels {
    font-size: 0.9em;
  }
</styles>